/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum DocumentsAliases {
  AUTOCOMPLETE_PROVIDER = 'autocomplete-provider',
  AVATAR_0 = 'avatar-0',
  CHECKBOX_0 = 'checkbox-0',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_DOCUMENT_TYPES = 'deck-document-types',
  FETCH_DOCUMENTS = 'fetch-documents',
  FETCH_PROVIDER = 'fetch-provider',
  FIELD_AVATAR = 'field-avatar',
  FIELD_PROVIDER = 'field-provider',
  FIELD_STATUS = 'field-status',
  FILTER_DOCS = 'filter-docs',
  FILTERED_LIST_0 = 'filtered-list-0',
  HPMS_CUSTOM_CARD_DOCUMENTS = 'hpms-custom-card-documents',
  MAPPER_0 = 'mapper-0',
  MAPPER_1 = 'mapper-1',
  PANEL_DOCUMENTS = 'panel-documents',
  TEXT_PROVIDER = 'text-provider',
}
export { DocumentsAliases };
